/**
 * Site header.
 */


// Module imports
import { ErrorHandler } from 'errorhandler/errorhandler.js';
import { i18n, __ } from "i18n/i18n.js";
import { MDCTextField } from "@material/textfield/dist/mdc.textfield.min.js";





/**
 * Module constants
 */
export const SEARCH_OVERLAY_FADE_TIME      = 300;

export const MOBILE_MENU_UPPER_BREAKPOINT  = 1240;

export const DESKTOP_MENU_LOWER_BREAKPOINT = 1241;





/**
 * Class for the main header.
 */
export class Header
{
	/**
	 * Determines if we're showing the mobile menu instead of the desktop menu.
	 *
	 * @return     {boolean}  True if mobile menu is active, false otherwise.
	 */
	static isMobileMenu()
	{
		try
		{
			return (
				MOBILE_MENU_UPPER_BREAKPOINT >= $( window ).width()
					? true
					: false
			);
		}
		catch( err )
		{
			Header.error( 'isMobileMenu', err );
		}
	}





	/**
	 * Determines if we're showing the desktop menu instead of the mobile menu.
	 *
	 * @return     {boolean}  True if desktop menu is active, false otherwise.
	 */
	static isDesktopMenu()
	{
		try
		{
			return (
				DESKTOP_MENU_LOWER_BREAKPOINT <= $( window ).width()
					? true
					: false
			);
		}
		catch( err )
		{
			Header.error( 'isDesktopMenu', err );
		}
	}





	/**
	 * Handles generic errors thrown by the class.
	 *
	 * @param      {string}  functionName  The function name where the error occured
	 * @param      {string}  errorMessage  The error message the error generated
	 */
	static error( functionName, errorMessage )
	{
		// Run it through the main error function
		ErrorHandler.error( 'Header', functionName, errorMessage );
	}





	/**
	 * Class constructor.
	 */
	constructor()
	{
		// Reference self
		let _this = this;

		// Member variables
		_this.$menu     = false;
		_this.$menuItem = false;
	}





	/**
	 * Adds the necessary event listeners.
	 */
	addListeners()
	{
		// Reference self
		let _this = this;

		// Wait for DOMContentLoaded
		$( document ).ready(
			function()
			{
				// Set menu element to member variable
				_this.$menu = $( 'header .nav-list' );

				// Handle initial state for window event based functions
				_this.handleMobileOnlyARIAAttributes();
				_this.collapseNavbarOnScroll();


				// Listen for clicks on the show/hide mobile menu button
				$( '#nav-toggle' ).on(
					'click',
					function()
					{
						// Toggle the mobile menu
						_this.toggleMobileMenu();
					}
				);


				// 
				// $( 'header .menu-item.menu-item-has-children[aria-expanded]:not(.depth-0)' ).on(
				// 	'mouseenter',
				// 	function()
				// 	{
				// 		// Reference submenu as we're gonna do quite a few things with it
				// 		let $submenu = $( this ).children( '.sub-menu' ).first();

				// 		// Set height to 0
				// 		$submenu.css( 'height', '0' );

				// 		// Set a data attribute with the scrollHeight
				// 		$submenu.attr( 'data-height', $submenu.get( 0 ).scrollHeight );

				// 		setTimeout(
				// 			function() {
				// 				// Animate to our target height
				// 				$submenu.animate(
				// 					{
				// 						'height': $submenu.attr( 'data-height' ),
				// 					},
				// 					200,
				// 					function()
				// 					{
				// 						// Set height to auto just in case something went wrong
				// 						$submenu.css( 'height', 'auto' );
				// 					}
				// 				);
				// 			},
				// 			100
				// 		);
				// 	}
				// );


				// Listen for clicks on submenu toggle buttons, although that's not what we REALLY want. HOWEVER, due to it being a button it acts more as a kind of button-scoped "submit" handler, allowing us to capture spacebar, enter, and other types of non-mouse input related to A11Y without having to check for specific keypress events or other input. One ring to rule them all...)
				$( 'header .submenu-toggler' ).on(
					'click',
					function()
					{
						// Toggle visibility of the related submenu
						_this.toggleSubmenuVisibility( $( this ) );
					}
				);


				// Listen for keypresses on links in menu
				$( 'header .menu-item a' ).on(
					'keypress',
					function( evt )
					{
						// Toggle visibility of the related submenu
						_this.goToLinkOnSpecificInput( evt );
					}
				);


				// Set A11Y state when hovering
				$( 'header .menu-item.menu-item-has-children[aria-expanded]' ).on(
					'mouseenter',
					function( evt )
					{
						// Set the element that we entered
						_this.$menuItem = $( this );

						// Open the menu
						_this.setSubmenuA11YState( true, evt );
					}
				);


				// Set A11Y state when mouse leaves menu
				$( 'header .menu-item.menu-item-has-children[aria-expanded]' ).on(
					'mouseleave',
					function( evt )
					{
						// Set the element that we exited
						_this.$menuItem = $( this );

						// Close the menu
						_this.setSubmenuA11YState( false, evt );
					}
				);


				// Listen for scroll events
				$( window ).scroll(
					function()
					{
						// Collapse navbar if necessary
						_this.collapseNavbarOnScroll();
					}
				);


				// Listen for window resize
				$( window ).on(
					'resize',
					function()
					{
						// Handle ARIA attributes that are only relevant for mobile
						_this.handleMobileOnlyARIAAttributes();
					}
				);
			}
		);
	}





	/**
	 * Collapse the navbar on scroll.
	 */
	collapseNavbarOnScroll()
	{
		// Reference self
		let _this = this;

		// Element references
		let $header      = $( 'header' );
		let $logo        = $( '.logo' );
		let $mobileNav   = $( '.nav-mobile' );
		let $mobileNavBG = $( '.nav-mobile-bg' );


		// If we've scrolled down on the page
		if ( 0 < $( window ).scrollTop() )
		{
			$header.addClass( 'header-bg-color' );
			$logo.addClass( 'logo-alt' );
			$mobileNav.addClass( 'scrolled' );
			$mobileNavBG.addClass( 'scrolled' );
		}
		// If we're at the top of the page
		else
		{
			$header.removeClass( 'header-bg-color' );
			$logo.removeClass( 'logo-alt' );
			$mobileNav.removeClass( 'scrolled' );
			$mobileNavBG.removeClass( 'scrolled' );
		}
	}





	/**
	 * Toggles visibility of the mobile menu.
	 */
	toggleMobileMenu()
	{
		// Reference self
		let _this = this;

		// Element references
		let $header         = $( 'header' );
		let $headerElements = $( '.nav-mobile, nav #nav-toggle, .nav-container' ).add( $header );
		let $toggleButton   = $( '#nav-toggle' );

		// Is header open?
		if ( $header.hasClass( 'open' ) )
		{
			// Remove the class from all elements signifying it's open
			$headerElements.removeClass( 'open' );

			// Set pressed status to false
			$toggleButton.attr( 'aria-pressed', 'false' );
		}
		// Not open
		else
		{
			// Add a class to all elements signifying it's open
			$headerElements.addClass( 'open' );

			// Set pressed status to false
			$toggleButton.attr( 'aria-pressed', 'true' );

			_this.workaroundOldIEBugs();
		}
	}




	/**
	 * Toggles visibility of the first submenu found after the clicked button.
	 *
	 * @param      {object}  $clickedButton  jQuery object for the clicked
	 *                                       button
	 */
	toggleSubmenuVisibility( $clickedButton )
	{
		// Reference self
		let _this = this;

		// Element references
		_this.$menuItem = $clickedButton.closest( '.menu-item' );

		// If the button is pressed since before (submenu open)
		if ( true === $clickedButton.attr( 'aria-pressed' ) || 'true' === $clickedButton.attr( 'aria-pressed' ) )
		{
			_this.setSubmenuA11YState( false );
		}
		else
		{
			_this.setSubmenuA11YState( true );
		}
	}





	/**
	 * Sets the necessary A11Y states related to a submenu.
	 *
	 * @param      {string}  state   The state
	 */
	setSubmenuA11YState( state = 'true', evt = false )
	{
		try
		{
			// Reference self
			let _this = this;

			// Make sure we have a menu item
			if ( null === _this.$menuItem || 0 >= _this.$menuItem.length )
			{
				throw 'You need to specify a menu item before attempting to set its A11Y state.';
			}

			// Only set state if criteria is met. This makes sure menu items are only affected if they have A11Y attributes since before and allows us to have hover effects on desktop and click effects in the mobile menu.
			if (
				// Menu item should have an A11Y state to begin with
				_this.$menuItem.get( 0 ).hasAttribute( 'aria-expanded' )
				&&
				(
					// We're in desktop mode
					true === Header.isDesktopMenu()
					||
					// Or if it wasn't a hover event
					(
						typeof evt.type === 'undefined'
						||
						(
							'mouseenter' !== evt.type
							&&
							'mouseleave' !== evt.type
						)
					)
				)
			)
			{
				// Convert to string for maximum consistency
				state = state.toString();

				// Set "pressed" state for toggle button
				_this.$menuItem.children( '.submenu-toggler' ).first().attr( 'aria-pressed', state );

				// Set "expanded" state for menu item
				_this.$menuItem.attr( 'aria-expanded', state );

				// If we're closing the submenu
				if ( 'false' === state )
				{
					// Close ALL submenus below this one
					_this.$menuItem.find( '.menu-item.menu-item-has-children[aria-expanded]' ).each(
						function()
						{
							$( this ).attr( 'aria-expanded', state );
						}
					);

					// Set ALL buttons below this one as unpressed
					_this.$menuItem.find( '.submenu-toggler' ).each(
						function()
						{
							$( this ).attr( 'aria-pressed', state );
						}
					);
				}
				// Opening the menu
				else
				{
					// Loop siblings
					_this.$menuItem.siblings().each(
						function()
						{
							// Overwrite menuItem (kinda fugly way to do this, but JS without React/Angular just isn't worth the time to run properly OOP)
							_this.$menuItem = $( this );

							// Close all other menus
							_this.setSubmenuA11YState( false );
						}
					);
				}
			}
		}
		catch( err )
		{
			Header.error( 'setSubmenuA11YState', err );
		}
	}





	/**
	 * Go to the currently focused link on certain types of A11Y related input.
	 *
	 * @param      {object}  evt     The event object
	 */
	goToLinkOnSpecificInput( evt )
	{
		try
		{
			// Reference self
			let _this = this;

			// Was that spacebar?
			if ( 32 === evt.keyCode )
			{
				// Stop browser from scrolling down, that just gets confusing
				evt.preventDefault();

				// Click the link
				evt.target.click();
			}
		}
		catch( err )
		{
			Header.error( 'goToLinkOnSpecificInput', err );
		}
	}





	/**
	 * Handles the ARIA attributes for the meun that only are relevant in mobile
	 * mode.
	 *
	 * While removing the attribute instead of adding it would be more
	 * mobile-first, we're doing it the opposite way here. The reason for that
	 * is that the desktop menu works without JS, while the mobile menu does
	 * not. Therefore we get better total compatibility by doing it this way, so
	 * don't go changing this later just to be trendy with 'mobile-first' and
	 * all that.
	 */
	handleMobileOnlyARIAAttributes()
	{
		try
		{
			// Reference self
			let _this = this;

			// Functionality
			let itemAction = false;


			// Make sure we've set the menu element
			if ( false === _this.$menu )
			{
				throw 'No menu element specified.';
			}


			// Are we in mobile menu mode but haven't applied the relevant ARIA attributes?
			if (
				true === Header.isMobileMenu()
				&&
				'false' === _this.$menu.attr( 'data-mobileariaapplied' ).toString()
			)
			{
				// Mark it as applied so we don't run necessary operations on the following resize events (until we come to desktop size again)
				_this.$menu.attr( 'data-mobileariaapplied', 'true' );

				// Set item action to apply attributes
				itemAction = 'apply';
			}
			// Are we in desktop menu mode and have applied the relevant ARIA attributes?
			else if (
				true === Header.isDesktopMenu()
				&&
				'true' === _this.$menu.attr( 'data-mobileariaapplied' ).toString()
			)
			{
				// Mark it as NOT applied so we don't run necessary operations on the following resize events (until we come to mobile size again)
				_this.$menu.attr( 'data-mobileariaapplied', 'false' );

				// Set item action to remove attributes
				itemAction = 'remove';
			}


			// Does it seem like we need to do anything?
			if ( false !== itemAction )
			{
				// Loop all sub menu items with attributes for mobile only ARIA
				_this.$menu.find( '.menu-item[data-mobilearia]' ).each(
					function()
					{
						// Element references
						let $menuItem = $( this );

						// Get attributes to change
						let attributes = JSON.parse( $menuItem.attr( 'data-mobilearia' ) );

						// Loop attributes
						for ( let attribute in attributes )
						{
							// Did we want to apply the attributes?
							if ( 'apply' === itemAction )
							{
								$menuItem.attr(
									attribute,
									attributes[ attribute ]
								);
							}
							// Nope, then remove them instead
							else
							{
								$menuItem.removeAttr( attribute );
							}
						}

						// If we're applying attrbiutes
						if ( 'apply' === itemAction )
						{
							// Also enable the toggler button
							$menuItem.children( '.submenu-toggler' ).first().removeAttr( 'aria-hidden' );
						}
						// Removing attributes
						else
						{
							// Also disable the toggler button
							$menuItem.children( '.submenu-toggler' ).first().attr( 'aria-hidden', 'true' );
						}
					}
				);
			}
		}
		catch( err )
		{
			Header.error( 'handleMobileOnlyARIAAttributes', err );
		}
	}





	/**
	 * Work around old IE. As always.
	 */
	workaroundOldIEBugs()
	{
		try
		{
			// Reference self
			let _this = this;

			// Are we using Internet Explorer and are we in mobile menu mode? 'cause if we're not then it doesn't matter
			if ( 'internet-explorer' === window.app.BrowserDetection.browserInfo.slug && true === Header.isMobileMenu() )
			{
				// Element references
				let firstLevelLinks = _this.$menu.children( '.menu-item' ).children( 'a' );

				console.log('isIE');

				// Loop links
				firstLevelLinks.each(
					function()
					{
						// Element references
						let $link = $( this );

						// Set margin to 0
						$link.css( 'margin-left', '0' );

						// Wait a bit...
						setTimeout(
							function()
							{
								// Reset margin and let the CSS handle it
								$link.css( 'margin-left', '' );
							},
							100
						);

					}
				);
			}
		}
		catch( err )
		{
			Header.error( 'workaroundOldIEBugs', err );
		}
	}
}





/**
 * Search class for the header.
 *
 * @class      Search (name)
 */
export class Search
{
	/**
	 * Adds the necessary event listeners.
	 */
	static addListeners()
	{
		// No touching until DOM is ready
		$( document ).on(
			'ready',
			function()
			{
				// Listen for clicks on the search button
				$( '.search-button__button' ).on(
					'click',
					function()
					{
						// Instantiate current class
						let Instance = new Search();

						// Set elements to member variables
						Instance.$showOverlayButton = $( this );

						// Show the overlay
						Instance.showSearchOverlay();
					}
				);
			}
		);
	}





	/**
	 * Class constructor.
	 */
	constructor()
	{
		// Member variables
		this.$showOverlayButton;
		this.$searchOverlay;
		this.$textField;
		this.$closeButton;
	}





	/**
	 * Renders the search overlay.
	 */
	renderSearchOverlay()
	{
		// Render the overlay at the end of body
		document.body.insertAdjacentHTML(
			'beforeend',
			`
				<div id="search-overlay" style="transition: opacity ${ SEARCH_OVERLAY_FADE_TIME }ms;">

					<form class="search-overlay__wrapper" action="${ __( 'searchURL', 'wisesite' ) }" method="GET">
						<div
						 class="mdc-text-field mdc-text-field--with-trailing-icon"
						>
							<input
							 name="s"
							 type="text"
							 class="mdc-text-field__input"
							 id="search-overlay__search-field"
							>
							<label
							 class="mdc-text-field__label"
							 for="search-overlay__search-field"
							>
								${ __( 'searchFieldLabel', 'wisesite' ) }
							</label>
							<button
							 type="submit"
							 class="search-overlay__submit-button mdc-text-field__icon"
							 tabindex="0"
							>
								<svg width="18px" height="16px" viewBox="0 0 18 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1294.000000, -47.000000)" stroke-linecap="round" stroke-linejoin="round">
										<g transform="translate(1296.000000, 49.000000)" stroke="#ffffff">
											<g>
												<path d="M10.3478261,4.8 C10.3478261,7.45086723 8.03167607,9.6 5.17391304,9.6 C2.3165471,9.6 0,7.45086723 0,4.8 C0,2.14913277 2.3165471,0 5.17391304,0 C8.03167607,0 10.3478261,2.14913277 10.3478261,4.8 Z" id="Stroke-1" stroke-width="2.5"></path>
												<path d="M8.82608696,8.21158879 L14,12" id="Stroke-3" stroke-width="2.5"></path>
											</g>
										</g>
									</g>
								</svg>
							</button>
							<div class="mdc-line-ripple"></div>
						</div>
					</form>

					<button type="button" class="search-overlay__close-button">
						<svg role="presentation" aria-hidden="true" width="28px" height="14px" viewBox="0 0 28 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-10.000000, -12.000000)">
								<g id="close" transform="translate(10.000000, 12.000000)">
									<path d="M9.93548387,4.375 L18.0645161,12.25" id="Line" stroke="#ffffff" stroke-width="1.134" stroke-linecap="round" stroke-linejoin="round"></path>
									<path d="M9.93548387,12.25 L18.0645161,4.375" id="Line-401" stroke="#ffffff" stroke-width="1.134" stroke-linecap="round" stroke-linejoin="round"></path>
								</g>
							</g>
						</svg>
					</button>
				</div>
			`
		);
	}





	/**
	 * Shows the search overlay.
	 */
	showSearchOverlay()
	{
		// Render the overlay
		this.renderSearchOverlay();

		// Set member variables with element references
		this.$searchOverlay = $( '#search-overlay' );
		this.$textField     = this.$searchOverlay.find( '.mdc-text-field' );
		this.$closeButton   = this.$searchOverlay.find( '.search-overlay__close-button' );

		// Instantiate the text field
		new MDCTextField( this.$textField[ 0 ] );

		// Push to the bottom of the callstack to make sure we don't add it before it gets a chance to render
		setTimeout(
			() =>
			{
				// Add the class that sets the styling
				this.$searchOverlay.addClass( 'solid' );
			},
			0
		);

		// When fade is done
		setTimeout(
			() =>
			{
				// Focus into the search field
				this.$textField.find( '.mdc-text-field__input' ).focus();
			},
			SEARCH_OVERLAY_FADE_TIME
		);

		// Listen for clicks on the close button
		this.$closeButton.on(
			'click',
			() =>
			{
				// Close the overlay
				this.closeOverlay();
			}
		);
	}





	/**
	 * Closes the search overlay.
	 */
	closeOverlay()
	{
		// Remove the class that sets the styling
		this.$searchOverlay.removeClass( 'solid' );

		// Wait half a second
		setTimeout(
			() =>
			{
				// Remove it entirely
				this.$searchOverlay.remove();
			},
			( SEARCH_OVERLAY_FADE_TIME + 50 )
		);
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/modules/header/header.js